import { ComponentChildren } from 'preact'
import LazyImage from '@insided/shared/uikit/LazyImage'

interface Props {
  children?: ComponentChildren
  type: 'img' | 'background'
  style?: Object
  src: string
  title?: string
  alt?: string
  classNames?: string
  displayOriginalImage?: boolean
}

/**
 * @deprecated use `import LazyImage from @insided/shared/uikit/LazyImage`
 */
const LazyLoader = ({ classNames, ...restProps }: Props) => (
  <LazyImage className={classNames} {...restProps} />
)

/**
 * @deprecated use `import LazyImage from @insided/shared/uikit/LazyImage`
 */
export default LazyLoader
